module.exports = __webpack_public_path__ + "img/right.20a5cc80.svg";